import React from 'react';
import { useRecoilValue } from 'recoil';
import url from '../../utils/config';
import loadingStatus from '../../states/loadingState';

/**
 * Recoil のローディング状態に応じて表示する軽量ローディングアイコン。
 * @returns ローディングアイコンまたは非表示プレースホルダ
 */
const LoadingIcon: React.FC = () => {
  const isLoading = useRecoilValue(loadingStatus);

  if (isLoading.length !== 0) {
    // ローディング中に背面スクロールを止め、処理待ち中の誤操作を防ぐ。
    if (typeof window === 'object') {
      document.body.style.overflow = 'hidden';
    }
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        <div className='loading_icon' data-testid='loading' role='status'>
          <img src={url('/images/icon_loader.gif')} alt='ローディング中' />
          <span className='visually-hidden'>読み込みちゅうです</span>
        </div>
      </>
    );
  }

  // ローディング終了後は body のスクロール抑止を必ず解除する。
  if (typeof window === 'object') {
    document.body.style.overflow = '';
  }
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      <div data-testid='hidden_loading' />
    </>
  );
};

export default LoadingIcon;
